<template>
  <Header headerShadow="header__area header__padding header__padding-2 header__shadow"/>
   <section class="page__title-area pt-90 pb-90">
   <div class="page__title-shape">
      <img class="page-title-shape-5 d-none d-sm-block" src="../assets/img/page-title/page-title-shape-1.png" alt="">
      <img class="page-title-shape-6" src="../assets/img/page-title/page-title-shape-6.png" alt="">
      <img class="page-title-shape-7" src="../assets/img/page-title/page-title-shape-4.png" alt="">
   </div>
   <div class="container">
      <div class="row">
         <div class="col-12">
            <div class="course__wrapper">
               <div class="page__title-content mb-25 pt-90">
                  <div class="page__title-breadcrumb">
                        <nav aria-label="breadcrumb">
                        <ol class="breadcrumb">
                           <li class="breadcrumb-item">
                              <router-link to="/">{{ $t('actions.home') }}</router-link>
                           </li>
                           <li class="breadcrumb-item active" aria-current="page">{{ news.category == 1 ? "E'lon" : "Yangiliklar" }}</li>
                        </ol>
                        </nav>
                  </div>
                  <span class="page__title-pre">{{ news.category == 1 ? "E'lon" : "Yangiliklar" }}</span>
                  <h5 class="page__title-3" style="font-size: 35px">
                    {{
                      getName({
                        nameLt: news.title,
                        nameUz: news.title_uz,
                        nameRu: news.title_ru,
                        nameEn: news.title_en,
                      })
                    }}
                  </h5>
               </div>

               <div class="course__img w-img">
                 <div class="course__slider swiper-container pb-40">
                  <img width="300" style="width: 100%; height: 100%; border-radius: 10px;" :src="baseUrl+news.image" alt="">
                   <swiper
                       ref="mySwiper"
                       class="d-none pb-50"
                       :space-between="25"
                       :slides-per-view="(news?.imageUrls?.length > 1) ? 2 : 1"
                       :modules="modules"
                       :pagination="{clickable: true}"
                       :loop="true"
                       :effect="'fade'"
                       :autoplay="{delay: 1000}"
                       :breakpoints="(news?.imageUrls?.length > 1) ? breakpoints2 : breakpoints1"
                   >
                     <swiper-slide v-for="(vm,index) in news.imageUrls" :key="index">
                       <div class="course__item course__item-3 swiper-slide white-bg mb-30 fix">
                         <div class="course__thumb w-img p-relative fix">

                           <img width="300" height="600" style="width: 100%; height: 100%;" :src="baseUrl+vm" alt="">
                           <div class="course__tag">
                             <span class="page__title-pre">{{
                                 getName({
                                   nameLt: news.categoryNameLt,
                                   nameUz: news.categoryNameUz,
                                   nameRu: news.categoryNameRu,
                                   nameEn: news.categoryNameEn,
                                 })
                               }}</span>
                           </div>
                         </div>
<!--                         <div class="course__content d-none">-->
<!--                           <div class="course__meta d-flex align-items-center justify-content-between">-->
<!--                             <div class="course__lesson">-->
<!--                               <span><i class="far fa-book-alt"></i>{{course?.lesson}} Lesson</span>-->
<!--                             </div>-->
<!--                             <div class="course__rating">-->
<!--                               <span><i class="icon_star"></i>{{course?.rating}} (44)</span>-->
<!--                             </div>-->
<!--                           </div>-->
<!--                           <h3 class="course__title">-->
<!--                             <router-link :to="`/course-details/${course.id}`">{{course?.title}}</router-link>-->
<!--                           </h3>-->
<!--                           <div class="course__teacher d-flex align-items-center">-->
<!--                             <div class="course__teacher-thumb mr-15">-->
<!--                               <img :src="course?.teacherImg" alt="">-->
<!--                             </div>-->
<!--                             <h6><router-link to="/instructor-details">{{course?.teacherName}}</router-link></h6>-->
<!--                           </div>-->
<!--                         </div>-->
<!--                         <div class="course__more d-none justify-content-between align-items-center">-->
<!--                           <div class="course__status d-flex align-items-center">-->
<!--                             <span :class="course.color">${{course.price}}</span>-->
<!--                             <span class="old-price">${{course.oldPrice}}</span>-->
<!--                           </div>-->
<!--                           <div class="course__btn">-->
<!--                             <router-link to="/course-details" class="link-btn">-->
<!--                               Know Details-->
<!--                               <i class="far fa-arrow-right"></i>-->
<!--                               <i class="far fa-arrow-right"></i>-->
<!--                             </router-link>-->
<!--                           </div>-->
<!--                         </div>-->
                       </div>
                     </swiper-slide>
                   </swiper>
                   <div class="swiper-pagination"></div>
                 </div>
               </div>
               <div class="course__tab-content mb-95">
                  <div class="tab-content" id="courseTabContent">
                     <div class="tab-pane fade show active mb-30" id="description" role="tabpanel" aria-labelledby="description-tab">
                        <div class="course__description">
                           <h3>{{ $t('actions.newsDetail') }}</h3>
                           <p v-html="getCourseTitle(news)"></p>
<!--                             {{-->
<!--                               getName({-->
<!--                                 nameUz: news.contentUz,-->
<!--                                 nameLt: news.contentLt,-->
<!--                                 nameRu: news.contentRu,-->
<!--                               })-->
<!--                             }}-->



                           <div class="course__instructor d-none mb-45">
                              <h3>Other Instructors</h3>
                              <div class="course__instructor-wrapper d-md-flex align-items-center">
                                 <div class="course__instructor-item d-flex align-items-center mr-70">
                                    <div class="course__instructor-thumb mr-20">
                                       <img src="../assets/img/course/teacher/teacher-3.jpg" alt="">
                                    </div>
                                    <div class="course__instructor-content">
                                       <h3>Eleanor Fant</h3>
                                       <p>Instructor</p>
                                    </div>
                                 </div>
                                 <div class="course__instructor-item d-flex align-items-center mr-70">
                                    <div class="course__instructor-thumb mr-20">
                                       <img src="../assets/img/course/teacher/teacher-2.jpg" alt="">
                                    </div>
                                    <div class="course__instructor-content">
                                       <h3>Lauren Stamps</h3>
                                       <p>Teacher</p>
                                    </div>
                                 </div>
                                 <div class="course__instructor-item d-flex align-items-center mr-70">
                                    <div class="course__instructor-thumb mr-20">
                                       <img src="../assets/img/course/teacher/teacher-1.jpg" alt="">
                                    </div>
                                    <div class="course__instructor-content">
                                       <h3>Jonquil Von</h3>
                                       <p>Associate</p>
                                    </div>
                                 </div>
                              </div>
                           </div>
                        </div>
                     </div>
                    <div class="course__meta-2 d-sm-flex mb-30">
                      <div class="course__teacher-3 d-flex align-items-center mb-30">
                        <div class="course__teacher-thumb-3 mr-15 d-none">
                          <img src="../assets/img/course/teacher/teacher-2.jpg" alt="">
                        </div>
                        <div class="course__teacher-info-3 d-none">
                          <h5>Author</h5>
                          <p><a href="#">Admin</a></p>
                        </div>
                      </div>
                      <div class="course__update mb-30">
                        <h5>{{ $t('actions.lastUpdate') }}:</h5>
                        <p>{{ news.updated_at?.slice(0, 10) }}</p>
                      </div>
                    </div>
                     <div class="course__share d-none">
                        <h3>Ulashish :</h3>
                        <ul>
                           <li>
                              <a href="#" class="pin" ><i class="fab fa-instagram"></i>
                           </a></li>
                           <li>
                              <a href="#" class="tw" ><i class="fab fa-telegram"></i>
                           </a></li>
                           <li>
                              <a href="#" class="tw" ><i class="fab fa-twitter"></i>
                           </a></li>
                        </ul>
                     </div>
                  </div>
               </div>
            </div>
         </div>

       <!-- course side bar start -->
<!--       <CourseSidebar :course-data="course"/>-->
       <!-- course side bar end -->
      </div>
   </div>
</section>

<!-- Footer -->
<Footer footerPadding="true"/>

</template>

<script>
import Header from '../components/HomeTwo/Header.vue';
import Footer from '../components/Home/Footer.vue';
import CourseItemMixin from '../mixins/courseItemsMixin';
// import CourseSidebar from '../components/CourseDetails/CourseSidebar.vue';
import {Swiper, SwiperSlide} from "swiper/vue";
import { Pagination } from "swiper";
import { mapGetters, mapActions } from 'vuex'
import BlogMixin from '@/mixins/blogMixin';
export default {
  name: "CourseDetailsPage",
  components:{
    Swiper,
    SwiperSlide,
		Header,
      // CourseSidebar,
      Footer
	},
    mixins: [CourseItemMixin, BlogMixin],
    data() {
        return {
            id: this.$route.params.id,
            course: {},
          breakpoints2: {
            550: { slidesPerView: 1,},
            768: { slidesPerView: 2,},
            992: { slidesPerView: 2,},
          },
          breakpoints1: {
            550: { slidesPerView: 1,},
            768: { slidesPerView: 1,},
            992: { slidesPerView: 1,},
          },
        }
    },
  computed:{
    ...mapGetters('news', ['news']),
  },
    methods: {
      ...mapActions('news', ['getNewsById']),
      getCourse(courseId) {
        this.course = this.courseItems.find(item => item.id == courseId);
      },
      getCourseTitle(course) {
        const shortName = this.getName({
          nameUz: course.text_uz,
          nameLt: course.text,
          nameRu: course.text_ru,
          nameEn: course.text_en,
        });
        return `<p>${shortName}</p>`;
      },
    },
    created() {
        this.getNewsById(this.id);
        this.getCourse(this.id);
    },
  setup() {
    return {
      modules: [Pagination],
    };
  },
};
</script>